module.exports = __webpack_public_path__ + "img/banner2.deef20b3.png";